import { ComponentTypes } from '@wix/wix-data-client-common'
import Button from './button'
import Checkbox from './checkbox'
import Column from './column'
import DatePicker from './datePicker'
import Dropdown from './dropdown'
import Gallery from './gallery'
import IconButton from './iconButton'
import Image from './image'
import MediaContainer from './mediaContainer'
import Page from './page'
import Pagination from './pagination'
import RadioButtonGroup from './radioButtonGroup'
import RatingsDisplay from './ratingsDisplay'
import RatingsInput from './ratingsInput'
import Repeater from './repeater'
import Slider from './slider'
import StripContainer from './stripContainer'
import Table from './table'
import Text from './text'
import TextBox from './textBox'
import RichTextBox from './richTextBox'
import TextInput from './textInput'
import ToggleSwitch from './toggleSwitch'
import UploadButton from './uploadButton'
import Video from './video'
import VideoPlayer from './videoPlayer'
import VideoBox from './videoBox'
import MusicPlayer from './musicPlayer'
import AddressInput from './addressInput'
import TimePicker from './timePicker'
import GoogleMap from './googleMap'
import CheckboxGroup from './checkboxGroup'
import StylableButton from './stylableButton'
import ProgressBar from './progressBar'
import VectorImage from './vectorImage'
import SelectionTags from './selectionTags'
import SignatureInput from './signatureInput'
import RichContent from './richContent'
import ClassicSection from './classicSection'

export const bindingDefinitionsByType = {
  [ComponentTypes.AddressInput]: AddressInput,
  [ComponentTypes.Button]: Button,
  [ComponentTypes.Checkbox]: Checkbox,
  [ComponentTypes.Column]: Column,
  [ComponentTypes.DatePicker]: DatePicker,
  [ComponentTypes.Dropdown]: Dropdown,
  [ComponentTypes.Gallery]: Gallery,
  [ComponentTypes.GoogleMap]: GoogleMap,
  [ComponentTypes.IconButton]: IconButton,
  [ComponentTypes.Image]: Image,
  [ComponentTypes.MediaContainer]: MediaContainer,
  [ComponentTypes.Page]: Page,
  [ComponentTypes.Pagination]: Pagination,
  [ComponentTypes.RadioButtonGroup]: RadioButtonGroup,
  [ComponentTypes.RatingsDisplay]: RatingsDisplay,
  [ComponentTypes.RatingsInput]: RatingsInput,
  [ComponentTypes.Repeater]: Repeater,
  [ComponentTypes.Slider]: Slider,
  [ComponentTypes.StripColumnsContainer]: StripContainer,
  [ComponentTypes.Table]: Table,
  [ComponentTypes.Text]: Text,
  [ComponentTypes.TextBox]: TextBox,
  [ComponentTypes.TimePicker]: TimePicker,
  [ComponentTypes.RichTextBox]: RichTextBox,
  [ComponentTypes.TextInput]: TextInput,
  [ComponentTypes.ToggleSwitch]: ToggleSwitch,
  [ComponentTypes.UploadButton]: UploadButton,
  [ComponentTypes.Video]: Video,
  [ComponentTypes.VideoPlayer]: VideoPlayer,
  [ComponentTypes.VideoBox]: VideoBox,
  [ComponentTypes.MusicPlayer]: MusicPlayer,
  [ComponentTypes.CheckboxGroup]: CheckboxGroup,
  [ComponentTypes.StylableButton]: StylableButton,
  [ComponentTypes.ProgressBar]: ProgressBar,
  [ComponentTypes.VectorImage]: VectorImage,
  [ComponentTypes.SelectionTags]: SelectionTags,
  [ComponentTypes.SignatureInput]: SignatureInput,
  [ComponentTypes.RichContent]: RichContent,
  [ComponentTypes.ClassicSection]: ClassicSection,
}
